import React, { useEffect, useState } from "react";
import SwipeableBottomSheet from "react-swipeable-bottom-sheet";
import { SendType } from "./Footer";
import { Button, Modal } from "antd";
import { ReactComponent as FilePDFIcon } from "../../../images/chat/file-pdf.svg";
import { ReactComponent as SoundUploadIcon } from "../../../images/chat/sound-mp3.svg";
import CloseCircleOutlined from "@ant-design/icons/lib/icons/CloseCircleOutlined";
import { calcBytes } from "../../../constant/helper";
import { MessageServerConstant, MessageType } from "../../../constant/Types";
import { PaperClipOutlined } from "@ant-design/icons";

const AttachmentInput = ({
  sendType,
  setSendType,
  limitedFileCount,
  sendMessage,
  rootType,
}) => {
  const [listFiles, setListFiles] = useState([]);

  function checkValidationFile(files, e) {
    // validation
    if (files.length > limitedFileCount) {
      Modal.warning({
        title: `شما مجاز به ارسال تنها ${limitedFileCount} فایل هستید`,
        okText: "متوجه شدم!",
      });
      return false;
    }

    if (files.length > 0) {
      const name = files[0]["name"];
      const accept = e.target.accept;

      if (
        accept.search("pdf") > -1 ||
        accept.search(".doc") > -1 ||
        accept.search(".docx") > -1
      ) {
        if (
          rootType === "consulting_and_reviewing_documents" &&
          (name.search("doc") > 0 || name.search("docx") > 0)
        ) {
          Modal.warning({
            title: ` شما تنها اجازه ارسال فایل pdf را دارید! `,
            okText: "متوجه شدم!",
          });
          return false;
        }
        if (
          name.search("pdf") < 0 &&
          name.search("doc") < 0 &&
          name.search("docx") < 0
        ) {
          Modal.warning({
            title: ` شما تنها اجازه ارسال فایل word,pdf را دارید! `,
            okText: "متوجه شدم!",
          });
          return false;
        }
      }

      if (accept.search("mp3") > -1) {
        if (files[0].size > 10 * 1024 * 1024) {
          Modal.warning({
            title: `شما مجاز به ارسال فایل تا حداکثر 10 مگابایت هستید`,
            okText: "متوجه شدم!",
          });
          return false;
        }

        if (name.search("mp3") < 0) {
          Modal.warning({
            title: ` شما تنها اجازه ارسال فایل mp3 را دارید! `,
            okText: "متوجه شدم!",
          });
          return false;
        }
      }

      if (accept.search("image") > -1) {
        if (
          name.search("jpg") < 0 &&
          name.search("jpeg") < 0 &&
          name.search("png") < 0 //&&
          // name.search("jpeg") < 0 &&
          // name.search("jpeg") < 0
        ) {
          Modal.warning({
            title: ` شما تنها اجازه ارسال فایل تصویری را دارید! `,
            okText: "متوجه شدم!",
          });
          return false;
        }
      }
    }

    return true;
  }

  function handleOnChangeFile(e) {
    const files = e.target.files;

    if (!checkValidationFile(files, e)) {
      return false;
    }

    // set state
    setListFiles(Object.values(files));
  }

  function handleAddFile(e) {
    let files = e.target.files;
    const name = files[0]["name"];

    files = Object.values(files);

    // validation
    if (name.search("mp3") > -1) {
      if (files[0].size > 10 * 1024 * 1024) {
        Modal.warning({
          title: `شما مجاز به ارسال فایل تا حداکثر 10 مگابایت هستید`,
          okText: "متوجه شدم!",
        });
        return false;
      }
    }

    if (
      name.search("pdf") < 0 &&
      name.search("mp3") < 0 &&
      name.search("jpg") < 0 &&
      name.search("jpeg") < 0 &&
      name.search("png") < 0
    ) {
      Modal.warning({
        title: ` شما تنها اجازه ارسال فایل pdf, mp3, png, jpeg,jpg را دارید! `,
        okText: "متوجه شدم!",
      });
      return false;
    }

    let res = [...files, ...listFiles];

    // set state
    setListFiles(res);
  }
  //
  // function sendBtn() {
  //   listFiles.forEach((item) => {
  //     let messageType = MessageServerConstant.document;
  //     if (item.type.search("image") > -1) {
  //       messageType = MessageServerConstant.images;
  //     }
  //
  //     if (item.type.search("audio") > -1) {
  //       messageType = MessageServerConstant.voice;
  //       // clientMessageType= MessageType.client.voice
  //     }
  //     sendMessage(MessageType.client.media, item, { messageType });
  //   });
  // }

  function sendBtn() {
    listFiles.forEach((item) => {
      let messageType = MessageServerConstant.document;

      if (item.type.search("image") > -1) {
        messageType = MessageServerConstant.images;
        sendMessage(MessageType.client.media, item, { messageType });
      } else if (item.type.search("audio") > -1) {
        let messageType = MessageServerConstant.voice;
        const reader = new FileReader();
        reader.readAsDataURL(item);
        reader.onloadend = function () {
          item = reader.result;

          const media = new Audio(item);
          media.onloadedmetadata = function () {
            // eslint-disable-next-line no-unused-expressions
            item = item.split(",");
            sendMessage(MessageType.client.voice, item[1], {
              duration: Math.ceil(media.duration),
              messageType,
            });
          };
        };
      } else {
        // sendMessage(messageType, item, { messageType });
        sendMessage(MessageType.client.media, item, { messageType });
      }
    });
  }

  useEffect(() => {
    if (sendType === SendType.free) {
      setListFiles([]);
    }
  }, [sendType]);

  return (
    <>
      <SwipeableBottomSheet
        overflowHeight={0}
        open={sendType === SendType.file.select}
        onChange={(state) => {
          if (state === false) {
            setSendType(SendType.free);
          }
        }}
        className={"file-select-holder unselectable"}
        swipeableViewsProps={{
          className: "record-hold-holder file-select-holder",
        }}
        style={{ zIndex: 99, background: "transparent" }}
      >
        {listFiles.length === 0 ? (
          <div className="unselectable file-select center-text">
            <h4 className={"title"}> بارگذاری فایل </h4>
            <div className="description rtl">
              لطفا فایل
              {rootType !== "consulting_and_reviewing_documents"
                ? "pdf,word,"
                : "pdf,"}
              صوتی یا تصویری را انتخاب نمایید
            </div>
            <div className="btn-holder">
              <div className="any-file-btn">
                <label className="center-flex" htmlFor={"image-selector"}>
                  <i className="icon icon-profile-camera" />
                </label>
                <div>عکس</div>
                <input
                  onChange={handleOnChangeFile}
                  style={{ display: "none" }}
                  type="file"
                  accept="image/*"
                  id="image-selector"
                  multiple
                />
              </div>

              <div className="any-file-btn">
                <label
                  className="center-flex sound-upload-icon-white"
                  htmlFor={"voice-selector"}
                >
                  <SoundUploadIcon />
                  {/* <i className="icon icon-profile-camera" /> */}
                </label>
                <div>صوت</div>
                <input
                  onChange={handleOnChangeFile}
                  style={{ display: "none" }}
                  type="file"
                  accept="audio/mp3"
                  id="voice-selector"
                  multiple
                />
              </div>

              <div className="img-file-btn">
                <label className="center-flex" htmlFor={"file-selector"}>
                  <PaperClipOutlined />
                </label>
                <div>فایل</div>
                <input
                  onChange={handleOnChangeFile}
                  style={{ display: "none" }}
                  type="file"
                  accept=".doc,.docx,application/pdf"
                  id="file-selector"
                  multiple
                />
              </div>
            </div>
          </div>
        ) : (
          <div
            className="unselectable file-select center-text file-preview-holder"
            style={{ paddingBottom: 30 }}
          >
            {listFiles &&
              listFiles.length > 0 &&
              listFiles.map((i, index) => {
                return (
                  <div key={`files-${index}`} className={"file-preview-item"}>
                    <div className="file-icon center-flex">
                      <FilePDFIcon />
                    </div>
                    <div className="file-data">
                      <div className="file-name">{i.name}</div>
                      <div className="file-size">{calcBytes(i.size)}</div>
                    </div>
                    <div
                      className="file-remove center-flex"
                      onClick={() => {
                        let res = [...listFiles];
                        res.splice(index, 1);
                        setListFiles(res);
                      }}
                    >
                      <CloseCircleOutlined />
                    </div>
                  </div>
                );
              })}

            <div className="submit-btn">
              <input
                onChange={handleAddFile}
                style={{ display: "none" }}
                type="file"
                id="file-add-selector"
                accept="audio/mp3, application/pdf, image/*"
                multiple
              />
              <label
                htmlFor={"file-add-selector"}
                className={"add-btn center-flex"}
              >
                افزودن
              </label>

              <Button className={"send-btn"} onClick={sendBtn}>
                ارسال
              </Button>
            </div>
          </div>
        )}
      </SwipeableBottomSheet>
    </>
  );
};

export default AttachmentInput;
